import Component from '@glimmer/component';
import { getPromiseState } from '@warp-drive/core/reactive';
import { t } from 'ember-intl';
import AlertBanner from 'tio-ui/components/alert-banner';
import Card from 'tio-ui/components/card';
import type { LoadedWidget } from 'tio-employee/routes/authenticated/admin/index';

interface WidgetFrameSignature {
  Args: {
    /** A registry entry and its data promise, started by the route and resolved here. */
    widget: LoadedWidget;
  };
}

/**
 * Resolves one widget's data and renders its loading, error, or loaded state,
 * so a slow or failing source never blanks the rest of the dashboard.
 */
export default class WidgetFrame extends Component<WidgetFrameSignature> {
  get state() {
    return getPromiseState(this.args.widget.data);
  }

  <template>
    <div data-test-partner-dashboard-widget={{@widget.definition.id}}>
      {{#if this.state.isPending}}
        <Card @radius="nested" @padding="sm" aria-busy="true">
          <div class="tio-col">
            <div class="h-4 w-1/3 tio-bg-skeleton rounded-full"></div>
            <div class="h-4 tio-bg-skeleton rounded-full"></div>
          </div>
        </Card>
      {{else if this.state.isError}}
        <AlertBanner @intent="danger" @title={{t "partner_dashboard.widget_error"}} />
      {{else}}
        {{#let @widget.definition.component as |Widget|}}
          <Widget @data={{this.state.result}} />
        {{/let}}
      {{/if}}
    </div>
  </template>
}
